export default __webpack_public_path__ + "static/media/coin-withdraw-main-menu.6b02d40c.svg";